import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // 🔥 Импортируем хук для перехода по страницам
import '../AllMotoModels.css';
import { sendFrontAction } from '../services/api'; 

const AllMotoModels = () => {
    const [motoModels, setMotoModels] = useState([]); 
    const [activeTab, setActiveTab] = useState('Все'); 
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate(); // 🔥 Инициализируем навигацию

    const TABS = ['Все', 'Sport', 'M', 'Tour', 'Roadster', 'Adventure'];

    useEffect(() => {
        // Запрашиваем наш новый экшен каталога
        sendFrontAction('motorrad_catalog', {}, 'GET')
            .then(responseData => {
                if (responseData && responseData.success && Array.isArray(responseData.data)) {
                    setMotoModels(responseData.data);
                }
                setLoading(false);
            })
            .catch(error => {
                console.error("Ошибка при загрузке каталога:", error);
                setLoading(false);
            });
    }, []);

    const categoriesToRender = activeTab === 'Все' 
        ? ['Sport', 'M', 'Tour', 'Roadster', 'Adventure'] 
        : [activeTab];

    if (loading) {
        return <div className="loading-container">Загрузка модельного ряда...</div>;
    }

    return (
        <div className="all-models-page">
            <header className="models-nav">
                <ul className="filter-tabs">
                    {TABS.map((tab) => (
                        <li 
                            key={tab} 
                            className={activeTab === tab ? 'active' : ''} 
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab}
                        </li>
                    ))}
                </ul>
            </header>

            {categoriesToRender.map((cat) => {
                const modelsInCurrentCategory = motoModels.filter(m => (m.Category || m.category) === cat);

                if (modelsInCurrentCategory.length === 0) return null;

                return (
                    <section key={cat} className="category-section">
                        <h2 className="category-title">{cat}</h2>
                        <div className="models-list-grid">
                            {modelsInCurrentCategory.map((model) => (
                                <div 
                                    key={model.id} 
                                    className="model-item"
                                    // 🔥 КЛИК: Перенаправляем на роут карточки (например, /motorrad/m-1000-rr)
                                    onClick={() => navigate(`/moto_models`)}  // `/motorrad/${model.slug}`
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className="image-wrapper">
                                        <img 
                                            src={model.bikeImage ? model.bikeImage : `/assets/placeholder.jpg`}
                                            className={`main-photo ${model.name === 'BMW M 1000 RR' ? 'special-style' : ''}`}
                                            alt={model.name} 
                                        />
                                    </div>
                                    <p className="model-name-label">{model.name}</p>

                                    {/* 🔥 КНОПКА ПРАЙС-ЛИСТА */}
                                    {model.pdfUrl ? (
                                        <a 
                                            href={model.pdfUrl} 
                                            target="_blank" 
                                            rel="noopener noreferrer" 
                                            className="btn-price-list"
                                            onClick={(e) => e.stopPropagation()} // Чтобы не срабатывал клик по карточке
                                        >
                                            Смотреть прайс-лист
                                        </a>
                                    ) : (
                                        <button className="btn-price-list disabled" disabled>
                                            Прайс отсутствует
                                        </button>
                                    )}
                                </div>
                            ))}
                        </div>
                    </section>
                );
            })}
        </div>
    );
};

export default AllMotoModels;